

























































































































































































































import { Component, Vue } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import VideoListItem from "@/components/GrammarToGo/VideoListItem.vue";

import BaseButton from "@/components/BaseButton/BaseButton.vue";
import AsyncButton from "@/components/BaseAsyncButton/BaseAsyncButton.vue";
import BasePopup from "@/components/BasePopup/BasePopup.vue";
import DataTable from "@/components/DataTable/DataTable.vue";
import { Action } from "vuex-class";
import {
  ImportStudentsPayload,
  ImportStudentsResponse
} from "@/models/interfaces/students";
import { AxiosPromise } from "axios";
import { exportCSVFile } from "@/utils/helpers/export-csv";

interface Column {
  disabled: boolean;
  label: string;
  items?: string[];
  id: string;
}

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderBackWithTitle,

    BaseButton,
    AsyncButton,
    BasePopup,
    DataTable,
    VideoListItem
  }
})
export default class StudentsImportView extends Vue {
  @Action("students/importStudents")
  private importStudents!: (
    data: ImportStudentsPayload[]
  ) => AxiosPromise<ImportStudentsResponse>;

  private pastedContent = "";

  private currentStep = 1;
  private updateKey = 0;

  private importError = false;
  private loading = false;

  private importedStudentsResponse!: ImportStudentsResponse;
  copyPasteFirst;
  private messages = {
    1: "Please copy and paste the first names of your students into the ‘First name’ text box.",
    2: "Please copy and paste the last names of your students into the ‘Last name’ text box.",
    3: "Great! Now let’s check that everything is correct. You can go back if you want to make any changes. Please check: both names of each student are correctly matched."
  };

  private columns: Column[] = [
    {
      disabled: false,
      label: "First name",
      id: "first-name"
    },
    {
      disabled: true,
      label: "Last name",
      id: "last-name"
    }
  ];

  private tableData: Array<{ firstName: string; lastName: string }> = [];

  private popup = {
    show: false,
    message: ""
  };

  private get tableColumns() {
    return [
      {
        label: this.$t("tables.reports.firstName"),
        value: "firstName"
      },
      {
        label: this.$t("tables.reports.lastName"),
        value: "lastName"
      }
    ];
  }

  private onPopupClose() {
    if (this.currentStep < 3 || this.importError) {
      this.popup.show = false;
    }
  }

  private generateCsvFile() {
    const headers = {
      firstname: this.$t("tables.reports.firstName") as string,
      lastname: this.$t("tables.reports.lastName") as string,
      username: this.$t("tables.reports.username") as string,
      password: this.$t("components.password") as string
    };

    const data =
      this.importedStudentsResponse.students.map(item => ({
        firstname: item.firstname,
        lastname: item.lastname,
        username: item.username,
        password: item.password
      })) || [];

    exportCSVFile(headers, data, "Imported students list.csv");
  }

  private async onSave() {
    this.loading = true;

    try {
      const { data } = await this.importStudents(
        this.tableData.map(item => ({
          firstname: item.firstName,
          lastname: item.lastName
        }))
      );
      this.loading = false;

      this.importedStudentsResponse = data;

      this.generateCsvFile();

      this.popup.message = this.$t(
        "views.students.import.thoseStudentsAdded"
      ) as string;
      this.popup.show = true;
    } catch (error) {
      this.loading = false;
      this.importError = true;
      this.popup.message = this.$t("errors.unexpected") as string;
      this.popup.show = true;
    }
  }

  private onBack() {
    if (this.currentStep === 1) {
      this.$router.push("/students");
    } else {
      this.currentStep--;
      const columnsSteps = [1, 2];

      if (columnsSteps.includes(this.currentStep)) {
        this.columns = this.columns.map(column => ({
          ...column,
          disabled: true
        }));
        const currentColumn = this.columns[this.currentStep - 1];
        this.pastedContent = currentColumn.items?.join("\n") || "";

        currentColumn.items = undefined;
        currentColumn.disabled = false;
      }
    }
  }

  private onContinue() {
    if (this.currentStep === 1) {
      this.onFirstStepContinue();
    } else if (this.currentStep === 2) {
      this.onSecondStepContinue();
    }
  }

  private onFirstStepContinue() {
    if (this.pastedContent) {
      const containsLines = /\r|\n/.exec(this.pastedContent);

      if (containsLines) {
        const pastedItems = this.pastedContent.split(/\r|\n/).filter(Boolean);
        this.columns[0].items = pastedItems;
        this.updateKey++;
        this.currentStep++;
        this.pastedContent = "";

        this.columns[1].disabled = false;
        this.columns[0].disabled = true;
      } else {
        this.popup.message = this.$t("views.students.errors.import") as string;
        this.popup.show = true;
      }
    } else {
      this.popup.message =
        (this.$t("views.students.errors.importPaste") as string) + ` 1`;
      this.popup.show = true;
    }
  }

  private onSecondStepContinue() {
    if (this.pastedContent) {
      const containsLines = /\r|\n/.exec(this.pastedContent);

      if (containsLines) {
        const pastedItems = this.pastedContent.split(/\r|\n/).filter(Boolean);

        if (pastedItems.length !== this.columns[0].items?.length) {
          this.popup.message = this.$t(
            "views.students.errors.import"
          ) as string;
          this.popup.show = true;
          return;
        }

        this.columns[1].items = pastedItems.filter(Boolean);
        this.updateKey++;
        this.pastedContent = "";

        this.columns[0].disabled = false;

        const data = this.columns.map(col => col.items || []);
        this.tableData = [];

        data[0].forEach((item, idx) => {
          this.tableData.push({
            firstName: item,
            lastName: data[1][idx]
          });
        });

        this.currentStep++;
      } else {
        this.popup.message = this.$t("views.students.errors.import") as string;
        this.popup.show = true;
      }
    } else {
      this.popup.message =
        (this.$t("views.students.errors.importPaste") as string) + ` 2`;
      this.popup.show = true;
    }
  }
}
